/*-------------------------------------------------------------------
みんなのオンクリ LP
--------------------------------------------------------------------*/

/**
 * アコーディオン（details / summary）
 * 開閉に高さアニメーションを付ける。JS が無効でも details の標準動作で開閉できる。
 */
function initAccordion() {
  const DURATION = 300;
  const EASING = 'ease-out';

  document.querySelectorAll('.js-accordion').forEach((details) => {
    const summary = details.querySelector('summary');
    const body = details.querySelector('.js-accordionBody');
    if (!summary || !body) return;

    let animation = null;

    const finish = () => {
      animation = null;
      body.style.height = '';
      body.style.overflow = '';
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (animation) animation.cancel();

      body.style.overflow = 'hidden';

      if (details.open) {
        const startHeight = `${body.offsetHeight}px`;
        details.classList.add('is-closing');
        animation = body.animate({ height: [startHeight, '0px'] }, { duration: DURATION, easing: EASING });
        animation.onfinish = () => {
          details.open = false;
          details.classList.remove('is-closing');
          finish();
        };
      } else {
        details.open = true;
        const endHeight = `${body.offsetHeight}px`;
        animation = body.animate({ height: ['0px', endHeight] }, { duration: DURATION, easing: EASING });
        animation.onfinish = () => {
          finish();
          // 中の横スクロール要素にヒントを出し直す
          window.dispatchEvent(new Event('resize'));
        };
      }
    });
  });
}

/**
 * 横スクロールのヒント（ScrollHint）
 * 料金プランの料金表など、幅が収まらない要素に「スクロールできます」を表示する。
 * PC はスクロールバーが出るのでヒントは不要。マウス操作の環境では出さない。
 */
function initScrollHint() {
  if (typeof ScrollHint === 'undefined') return;
  if (!document.querySelector('.js-scrollable')) return;
  // マウス操作かつ画面が広い＝PC。スクロールバーで気づけるのでヒントは出さない
  // （幅だけで判定すると、ウィンドウを狭めた確認時に出なくなるので併用する）
  if (window.matchMedia('(min-width: 768px) and (any-hover: hover) and (any-pointer: fine)').matches) return;

  new ScrollHint('.js-scrollable', {
    suggestiveShadow: true,
    i18n: { scrollable: 'スクロールできます' },
  });

  // ScrollHint は overflow: auto をインラインで打つ。行数の少ない表では
  // ヒントのアイコン（高さ 92px 固定）が表からはみ出して縦スクロールが出るので塞ぐ
  document.querySelectorAll('.js-scrollable').forEach((el) => {
    el.style.overflowY = 'hidden';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAccordion();
  initScrollHint();
});
